import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";

function MainButton({
  color,
  bg,
  cN,
  arrowColor = "text-[#FF0336]",
  hover,
  text,
  goTo,
  icon,
}) {
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Link
      onClick={goTop}
      to={goTo}
      className={`text-[13px] sm:text-[15px] ${color} ${bg} ${cN} inline-flex items-center justify-center gap-2 font-[600] px-6 py-3.5 sm:py-4 uppercase hero-cta relative rounded transition duration-300 ${hover}`}
    >
      {icon && <span>{icon}</span>}
      <span>{text}</span>
      <FaArrowRight className={`${arrowColor} text-[14px] shrink-0`} />
    </Link>
  );
}

export default MainButton;